import {Color} from "three";
import * as THREE from "three";

function generateTexture() {

    const canvas = document.createElement( 'canvas' );
    canvas.width = 2;
    canvas.height = 2;

    const context = canvas.getContext( '2d' );
    context.fillStyle = 'white';
    context.fillRect( 0, 1, 2, 1 );

    return canvas;

}

//const texture = new THREE.CanvasTexture( generateTexture() );

export const MATERIAL_PROPS_DB = [


    {
        materialName: "GlassMat",
        glass: true,
        glassMatFunc: (envMap) => {
            return new THREE.MeshPhysicalMaterial({
                name: `GlassMat-MPM`,
                color: new THREE.Color(0xffffff),
                emissive :new THREE.Color( 0.20969663085937498, 0.21999999999999997, 0.21999999999999997 ),
                metalness: .01,
                roughness: 0.3454902630679877,
                // alphaMap: texture,
               // alphaTest: 0.5,
                //envMap: envMap, //this.backgroundMap,
                envMapIntensity: .572,
                //depthWrite: false,
                transmission: 1, // use material.transmission for glass materials
                opacity: .34, // set material.opacity to 1 when material.transmission is non-zero
                transparent: true,
                //ior: 1.5,
                //specularIntensity: 1,
                //specularColor: 0xffffff,
              //  side: THREE.DoubleSide,
                //alphaMap: texture,
                toneMapped:false,
            });
        },
    },

    {
        materialName:"I_UV_01",
        toneMapped:'N',
    },
    {
        materialName:"I_UV_02",
        toneMapped:'N',

    },
    {
        materialName:"I_UV_03",
        toneMapped:'N',
    },
    {
        materialName:"I_UV_04",
        toneMapped:'N',
    },

    {
        materialName:"WallMat",
        aOIntensity:0.9380765288691493,

        envMapIntensity:0.12256576699692519,

        roughness:1,
        metalness:1,
        toneMapped:'N',

    },


    {
        materialName:"LedgesMat.001",
        aOIntensity:0,
        envMapIntensity:6.397933037239494,
        roughness:0.5,
        toneMapped:'Y',

    },

    {
        materialName: "CeilingMat",
        aOIntensity:0.1181243594123676,

        envMapIntensity:1.59,
        roughness:0.5,
    },
    {
        materialName: "HDRIMaterial",
        toneMapped:'N',
    },


    {
        materialName:"FloorMat",
        aOIntensity:0.905278442090878,
        envMapIntensity:3.030662794670311,
        roughness:0.4548172189955586,
        metalness:0.66,
        toneMapped:'Y',
    },

    {
        materialName: "Window_material",
        toneMapped:'N',
    }


]
